import { WppTypography } from '@platform-ui-kit/components-library-react'
import clsx from 'clsx'
import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import appStoreLinkImg from 'assets/app-store-link.png'
import appStoreQR from 'assets/app_store_qr.svg'
import playMarketLinkImg from 'assets/play-market-link.png'
import playMarketQR from 'assets/play_market_qr.svg'
import { Flex } from 'components/common/flex/Flex'
import styles from 'components/smallScreenBoundary/SmallScreenBoundary.module.scss'
import { IOS_DEVICES_PATTERN, useDeviceView } from 'components/smallScreenBoundary/utils'
import { SvgSmallScreen } from 'components/svg/renderError/SvgSmallScreen'

export const SmallScreenBoundary = ({ children }: PropsWithChildren<{}>) => {
  const { t } = useTranslation()
  const { isMobileView, isDesktopView } = useDeviceView()
  const isIOSDevice = IOS_DEVICES_PATTERN.test(navigator.userAgent)

  return (
    <>
      <Flex
        // Using a global class to be able to hide it from outside for dev purposes
        className={clsx('os-small-screen-overlay', 'error-boundary', {
          [styles.disabled]: process.env.DEV,
        })}
        direction="column"
        align="center"
        justify="center"
        data-testid="small-screen-boundary"
      >
        <SvgSmallScreen />

        <Flex className={clsx(styles.textWrapper, 'wrapper')} direction="column" align="center" justify="center">
          <WppTypography className={clsx('text')} type={isMobileView ? 'xs-strong' : 'm-strong'}>
            {t('os.small_screen_error.main_title')}
          </WppTypography>
          <WppTypography type={isMobileView ? 'xs-strong' : 'm-strong'}>
            {isMobileView ? t('os.small_screen_error.sub_title_mobile') : t('os.small_screen_error.sub_title')}
          </WppTypography>

          <Flex gap={24}>
            {(!isMobileView || isIOSDevice) && (
              <Flex direction="column" align="center" data-testid="app-store-links">
                {!isMobileView && (
                  <img className={styles.qrCode} src={appStoreQR} alt={t('os.small_screen_error.app_store_qr')} />
                )}
                {!isDesktopView && (
                  <a className={styles.linkButton} href="https://apps.apple.com/gb/app/wpp-open/id6630386999">
                    <img
                      slot="icon-start"
                      src={appStoreLinkImg}
                      width="120"
                      height="40"
                      alt={t('os.small_screen_error.app_store_link')}
                    />
                  </a>
                )}
              </Flex>
            )}
            {(!isMobileView || !isIOSDevice) && (
              <Flex direction="column" align="center" data-testid="play-market-links">
                {!isMobileView && (
                  <img className={styles.qrCode} src={playMarketQR} alt={t('os.small_screen_error.play_market_qr')} />
                )}
                {!isDesktopView && (
                  <a
                    className={styles.linkButton}
                    href="https://play.google.com/store/apps/details?id=com.wpp.open.android"
                  >
                    <img
                      slot="icon-start"
                      src={playMarketLinkImg}
                      width="120"
                      height="40"
                      alt={t('os.small_screen_error.play_market_link')}
                    />
                  </a>
                )}
              </Flex>
            )}
          </Flex>
        </Flex>
      </Flex>

      {children}
    </>
  )
}
